import { OauthAEMConfig } from '../models';

export const AuthConfigMocks: OauthAEMConfig = {
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE: 'openid',
  MFA_SCOPE_VALUE: 'openid custapi.personaldata.read_only',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'deltacom',
  MFA_CLIENT_ID_VALUE: 'deltacom',
  MFA_ACTION: 'mfaAction',
  MFA_ACTION_VALUE: 'existingusersetup',
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  PERSISTENT_LOGIN_ENABLE: true,
  PERSISTENT_COOKIE_TIMER: 0.01875,
  ENABLE_PING_LOGOUT: true,
  IS_USER_REMEMBERED: 'IS_USER_REMEMBERED',
  ISSUER_PROD: 'https://signin-si.delta.com',
  LOG_OUT_URL: '/idp/startSLO.ping?TargetResource=',
  REMEMBERED_DEVICE_DETAILS: 'REMEMBERED_DEVICE_DETAILS',
  REMEMBERME_API_FLOW_ENABLE: true,
  SCOPE_VALUE_RM: 'openid',
  SHOULD_REMEMBER_USER: 'SHOULD_REMEMBER_USER',
  VERSION_PARAMETER: 'v',
  VERSION_PARAMETER_VALUE: '1',
  VERIFY_EMAIL_MFA: 'verifyemailmfa',
  VERIFY_EMAIL_MFA_VALUE: 'yes',
  RESUME: 'RESUME',
  PING_DOMAIN: 'https://signin-si.delta.com',
  PING_FLOW_ENABLED: true,
  BFF_CODES_TO_IGNORE: "['22', '127', '30', '51']",
  NU_TRAVEL_URL: [
    'https://businessmanagement.delta.com/',
    'https://deltauat-web01.nutravel.com/'
  ],
  IS_EMAIL_ALLOWED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  AWS_ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  BAU_URLS: [
    'delta.com/mytrips/',
    'delta.com/vacations/',
    'delta.com/contactus/',
    'delta.com/buygftxfer/',
    'delta.com/skyclub/',
    'delta.com/cartalacarte/',
    'delta.com/seat/'
  ],
  COOKIE_DOMAIN: ';domain=.delta.com; path=/',
  COOKIE_DOMAIN_VALUE: '.delta.com',
  LOGIN_URLS: [
    '/login/loginPage',
    '/user-login/loginPage',
    '/user-login/forgotLogin',
    '/user-login/resetPassword',
    '/user-login/createPassword',
    '/user-login/loginHelp',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  REDIRECTION_URLS: [
    '/skymiles/login',
    '/skymiles/forgotLogin/',
    '/skymiles/resetPassword/',
    '/skymiles/loginHelp/',
    '/skymiles/addSQA',
    '/skymiles/addAddress',
    '/skymiles/addEmail'
  ],
  PHASE_ONE_URLS: [
    '',
    '/us/en/need-help/overview',
    '/us/en/need-help/support-skymiles',
    '/us/en/need-help/support-other-information'
  ],
  LOGIN_PICKER: '/skymiles/profilePickerPage',
  LOGIN_PICKER_STANDALONE: '/skymiles/profilePickerPage',
  DELETE_STANDALONE_COOKIE: true,
  MAKE_PE_CALL: true,
  ENABLE_NEW_PROFILE_SELECTOR: true,
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['200', '400', '404'],
  ENABLE_NEW_PERSISTENT_LOGIN: true,
  REGISTER_SW_URL: '/skymiles/login-sw.js?2=1',
  FTWR_LOGIN_MODAL_COOKIE_AGE: 30,
  LOGIN_STANDALONE_PAGE_URL: '/skymiles/login',
  REDIRECT_REFRESH_URLS: ['/content/www/acs/landing.html'],
  ORION_FLYOUT: true,
  CLEAR_CKO_COOKIE: true,
  PROFILE_PAGE_URL: '/myprofile',
  MFA_FLOW: true,
  FLY_DELTA_POLLING_TIMER: 5000,
  VERIFICATION_SCREEN_TIMER: 3000,
  ONE_TIME_PASSCODE_TIMER: 600,
  NEW_RESET_PASSWORD_FLOW: true,
  MFA_URLS: ['delta.com/skymiles/login'],
  FLY_DELTA_COOL_DOWN_TIME: 121,
  MFA_SETUP_LATER_TIMER: 30,
  REGISTRATION_RETRY_COUNT: 2,
  REGISTRATION_RETRY_TIMER: 3000,
  DISABLE_SQA_SCREEN: true,
  TOKEN_HEADER: true,
  MFA_TIMEOUT: 10000,
  LOGIN_TIMEOUT: 10000,
  LOGIN_RETRY_COUNT: 2,
  LOGIN_RETRY_TIMER: 3000,
  MFA_STUDIO_CONFIG_ID: 'c9fe9f7a-2ee5-4889-b753-5913244b71b0'
};

export const idpConfig: OauthAEMConfig = {
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE:
    'openid profile email given_name middle_name family_name preferred_username',
  SCOPE_VALUE_RM: 'openid',
  MFA_SCOPE_VALUE: 'openid custapi.personaldata.read_only',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'deltacom',
  MFA_CLIENT_ID_VALUE: 'deltacom',
  MFA_ACTION: 'mfaAction',
  MFA_ACTION_VALUE: 'existingusersetup',
  MFA_ACTION_SSPR_VALUE: 'sspr',
  ISSUER: [
    {
      ['dvl']: 'https://signin-si.delta.com',
      ['qat']: 'https://signin-si.delta.com',
      ['stg']: 'https://signin-si.delta.com',
      ['prd']: 'https://signin.delta.com'
    }
  ],
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  PERSISTENT_LOGIN_ENABLE: true,
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  VERIFY_EMAIL_MFA: 'verifyemailmfa',
  VERIFY_EMAIL_MFA_VALUE: 'yes',
  PERSISTENT_COOKIE_TIMER: 0.01875,
  INTROSPECTION: '/as/introspect.oauth2',
  INTROSPECTION_CLIENT: 'rs_client',
  IS_USER_REMEMBERED: '',
  SHOULD_REMEMBER_USER: '',
  REMEMBERED_DEVICE_DETAILS: '',
  PING_DOMAIN: 'https://signin-si.delta.com',
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['200', '400', '404'],
  REMEMBERME_API_FLOW_ENABLE: false,
  VERSION_PARAMETER_VALUE: '1',
  ENABLE_PING_LOGOUT: false,
  IS_EMAIL_ALLOWED: false,
  COOKIE_DOMAIN: '',
  PING_FLOW_ENABLED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: false,
  BAU_URLS: [''],
  BFF_CODES_TO_IGNORE: '',
  NU_TRAVEL_URL: [''],
  ISSUER_PROD: '',
  LOG_OUT_URL: '',
  RESUME: '',
  VERSION_PARAMETER: 'v',
  COOKIE_DOMAIN_VALUE: '',
  LOGIN_URLS: [''],
  REDIRECTION_URLS: [''],
  PHASE_ONE_URLS: [''],
  LOGIN_PICKER: '',
  LOGIN_PICKER_STANDALONE: '',
  DELETE_STANDALONE_COOKIE: false,
  MAKE_PE_CALL: false,
  ENABLE_NEW_PROFILE_SELECTOR: false,
  FTWR_LOGIN_MODAL_COOKIE_AGE: 0,
  ENABLE_NEW_PERSISTENT_LOGIN: false,
  REGISTER_SW_URL: ''
};

export const idpConfigPersistentLogin: OauthAEMConfig = {
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE:
    'openid profile email given_name middle_name family_name preferred_username',
  SCOPE_VALUE_RM: 'openid',
  MFA_SCOPE_VALUE: 'openid custapi.personaldata.read_only',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'deltacom',
  MFA_CLIENT_ID_VALUE: 'deltacom',
  MFA_ACTION: 'mfaAction',
  MFA_ACTION_VALUE: 'existingusersetup',
  MFA_ACTION_SSPR_VALUE: 'sspr',
  ISSUER: [
    {
      ['dvl']: 'https://signin-si.delta.com',
      ['qat']: 'https://signin-si.delta.com',
      ['stg']: 'https://signin-si.delta.com',
      ['prd']: 'https://signin.delta.com'
    }
  ],
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  PERSISTENT_LOGIN_ENABLE: true,
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  VERIFY_EMAIL_MFA: 'verifyemailmfa',
  VERIFY_EMAIL_MFA_VALUE: 'yes',
  PERSISTENT_COOKIE_TIMER: 0.01875,
  INTROSPECTION: '/as/introspect.oauth2',
  INTROSPECTION_CLIENT: 'rs_client',
  IS_USER_REMEMBERED: '',
  SHOULD_REMEMBER_USER: '',
  REMEMBERED_DEVICE_DETAILS: '',
  PING_DOMAIN: 'https://signin-si.delta.com',
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['200', '400', '404'],
  REMEMBERME_API_FLOW_ENABLE: false,
  VERSION_PARAMETER_VALUE: '1',
  ENABLE_PING_LOGOUT: false,
  IS_EMAIL_ALLOWED: false,
  COOKIE_DOMAIN: '',
  PING_FLOW_ENABLED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: false,
  BAU_URLS: [''],
  BFF_CODES_TO_IGNORE: '',
  NU_TRAVEL_URL: [''],
  ISSUER_PROD: '',
  LOG_OUT_URL: '',
  RESUME: '',
  VERSION_PARAMETER: 'v',
  COOKIE_DOMAIN_VALUE: '',
  LOGIN_URLS: [''],
  REDIRECTION_URLS: [''],
  PHASE_ONE_URLS: [''],
  LOGIN_PICKER: '',
  LOGIN_PICKER_STANDALONE: '',
  DELETE_STANDALONE_COOKIE: false,
  MAKE_PE_CALL: false,
  ENABLE_NEW_PROFILE_SELECTOR: false,
  FTWR_LOGIN_MODAL_COOKIE_AGE: 0,
  ENABLE_NEW_PERSISTENT_LOGIN: true,
  REGISTER_SW_URL: ''
};

export const fakeIdpConfig: OauthAEMConfig = {
  OAUTH2: '',
  RESPONSE_TYPE: '',
  RESPONSE_TYPE_VALUE: '',
  SCOPE: '',
  SCOPE_VALUE_RM: '',
  SCOPE_VALUE: '',
  RESPONSE_MODE: '',
  RESPONSE_MODE_VALUE: '',
  CODE_CHALLENGE: '',
  OAUTH2_USER_CREDENTIALS: '',
  OAUTH2_TOKEN: '',
  OPEN_ID: '',
  GRANT_TYPE: '',
  AUTHORIZATION_CODE: '',
  CODE: '',
  CODE_VERIFIER: '',
  CLIENT_ID: '',
  CLIENT_ID_VALUE: '',
  ISSUER: [],
  USERNAME_PASSWORD_REQUIRED: '',
  COMPLETED: '',
  CODE_CHALLENGE_METHOD_VALUE: '',
  CODE_CHALLENGE_METHOD: '',
  PERSISTENT_LOGIN_ENABLE: false,
  PROMPT: '',
  PROMPT_VALUE: '',
  LEVEL_OF_TRUST: '',
  LEVEL_OF_TRUST_VALUE: '',
  PERSISTENT_COOKIE_TIMER: 0,
  IS_USER_REMEMBERED: '',
  SHOULD_REMEMBER_USER: '',
  REMEMBERED_DEVICE_DETAILS: '',
  REMEMBERME_API_FLOW_ENABLE: false,
  VERSION_PARAMETER: '',
  VERSION_PARAMETER_VALUE: '',
  RESUME: '',
  LOG_OUT_URL: '',
  ISSUER_PROD: '',
  ENABLE_PING_LOGOUT: false,
  INTROSPECTION: '',
  INTROSPECTION_CLIENT: '',
  PING_DOMAIN: '',
  PING_FLOW_ENABLED: false,
  BFF_CODES_TO_IGNORE: '',
  NU_TRAVEL_URL: [''],
  IS_EMAIL_ALLOWED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: false,
  BAU_URLS: [''],
  COOKIE_DOMAIN: '',
  COOKIE_DOMAIN_VALUE: '',
  LOGIN_URLS: [''],
  REDIRECTION_URLS: [''],
  PHASE_ONE_URLS: [''],
  LOGIN_PICKER: '',
  LOGIN_PICKER_STANDALONE: '',
  DELETE_STANDALONE_COOKIE: false,
  MAKE_PE_CALL: false,
  ENABLE_NEW_PROFILE_SELECTOR: false,
  FTWR_LOGIN_MODAL_COOKIE_AGE: 0,
  ENABLE_NEW_PERSISTENT_LOGIN: false,
  REGISTER_SW_URL: '',
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['']
};

export const getHeaderConfigJsonRes = {
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE: 'openid',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'deltacom',
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  PERSISTENT_LOGIN_ENABLE: true,
  PERSISTENT_COOKIE_TIMER: 0.01875,
  ENABLE_PING_LOGOUT: true,
  IS_USER_REMEMBERED: 'IS_USER_REMEMBERED',
  ISSUER_PROD: 'https://signin-si.delta.com',
  LOG_OUT_URL: '/idp/startSLO.ping?TargetResource=',
  REMEMBERED_DEVICE_DETAILS: 'REMEMBERED_DEVICE_DETAILS',
  REMEMBERME_API_FLOW_ENABLE: true,
  SCOPE_VALUE_RM: 'openid',
  SHOULD_REMEMBER_USER: 'SHOULD_REMEMBER_USER',
  VERSION_PARAMETER: 'v',
  VERSION_PARAMETER_VALUE: '1',
  ISSUER_WIFI_PORTAL: 'https://signin-si.delta.com',
  RESUME: 'RESUME',
  PING_DOMAIN: 'https://signin-si.delta.com',
  PING_FLOW_ENABLED: true,
  BFF_CODES_TO_IGNORE: "['22', '127', '30', '51']",
  NU_TRAVEL_URL: [
    'https://businessmanagement.delta.com/',
    'https://deltauat-web01.nutravel.com/'
  ],
  IS_EMAIL_ALLOWED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  BAU_URLS: [
    'delta.com/mytrips/',
    'delta.com/vacations/',
    'delta.com/contactus/',
    'delta.com/buygftxfer/',
    'delta.com/skyclub/',
    'delta.com/cartalacarte/',
    'delta.com/seat/'
  ],
  COOKIE_DOMAIN: ';domain=.delta.com; path=/',
  COOKIE_DOMAIN_VALUE: '.delta.com',
  LOGIN_URLS: [
    '/login/loginPage',
    '/user-login/loginPage',
    '/user-login/forgotLogin',
    '/user-login/resetPassword',
    '/user-login/createPassword',
    '/user-login/loginHelp',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  REDIRECTION_URLS: [
    '/skymiles/login',
    '/skymiles/forgotLogin/',
    '/skymiles/resetPassword/',
    '/skymiles/loginHelp/',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  PHASE_ONE_URLS: [
    '',
    '/us/en/need-help/overview',
    '/us/en/need-help/support-skymiles',
    '/us/en/need-help/support-other-information'
  ],
  LOGIN_PICKER:
    '/content/www/en_US/global-login/loginmodalpage.html/skymiles/profilePickerPage/',
  LOGIN_PICKER_STANDALONE: '/skymiles/profilePickerPage',
  DELETE_STANDALONE_COOKIE: true,
  MAKE_PE_CALL: true,
  ENABLE_NEW_PROFILE_SELECTOR: true,
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['200', '400', '404'],
  ENABLE_NEW_PERSISTENT_LOGIN: false,
  REGISTER_SW_URL: '/skymiles/login-sw.js?1=17',
  FTWR_LOGIN_MODAL_COOKIE_AGE: 30,
  INTEGRATE_LAUNCH_DARKLY_CLIENT_SDK: true
};

export const featureFlags = {
  'enable-new-persistent-login': false,
  'enable-new-profile-selector': false,
  'enable-persistent-login-local-storage-check': false,
  'enable-widget-expander': true,
  enableNewProfileSelector: true,
  'migrate-login-modal-page': 'old'
};

export const contextObjMock = {
  kind: 'user',
  key: 'context-key'
};
